<template>
    <div>
      <h2>账号分组页面</h2>
      <p>这是账号分组的测试页面。</p>
    </div>
  </template>
  
  <script>
  export default {
    name: "MaterialCenter"
  };
  </script>
  
  <style scoped>
  /* 添加样式 */
  </style>
  